import { AndroidHttpClient } from './utils/android-http-client';
import { filter_mobile_alarms_data } from '../helpers/utilities';
import type { NativeHomesPayload, NativeProfilesPayload } from '../helpers/native_bridge_helpers';

const shellyHttpClient = new AndroidHttpClient();

export async function set_devices_data_android(user_data, devices) {
	try {
		const res = await shellyHttpClient.get(
			'shelly://device_list/?d=' +
				encodeURIComponent(JSON.stringify({ userdata: user_data, devices: devices })),
		);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function set_rooms_data_android(rooms) {
	try {
		const res = await shellyHttpClient.get(
			'shelly://room_list/?r=' + encodeURIComponent(JSON.stringify(rooms)),
		);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function set_groups_data_android(groups) {
	try {
		const res = await shellyHttpClient.get(
			'shelly://group_list/?r=' + encodeURIComponent(JSON.stringify(groups)),
		);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function set_scenes_data_android(scenes) {
	try {
		const res = await shellyHttpClient.get(
			'shelly://scene_list/?s=' + encodeURIComponent(JSON.stringify(scenes)),
		);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function set_alarms_data_android(scenes) {
	try {
		const res = await shellyHttpClient.get(
			'shelly://alarms_list/?a=' +
				encodeURIComponent(JSON.stringify(filter_mobile_alarms_data(scenes))),
		);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function set_profiles_data_android(payload: NativeProfilesPayload) {
	try {
		const res = await shellyHttpClient.get(
			'shelly://profiles_info/?p=' + encodeURIComponent(JSON.stringify(payload)),
		);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function set_homes_data_android(homes: NativeHomesPayload) {
	try {
		const res = await shellyHttpClient.get(
			'shelly://homes_list/?h=' + encodeURIComponent(JSON.stringify(homes)),
		);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function home_switched_android(unitId: string, subId?: string) {
	try {
		const subParam = subId ? `&sub=${encodeURIComponent(subId)}` : '';
		const res = await shellyHttpClient.get(
			`shelly://home_switched/?id=${encodeURIComponent(unitId)}${subParam}`,
		);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}
